import { createFileRoute } from '@tanstack/react-router';

import { Page } from '@/components/layout/Page';
import { PageHeader } from '@/components/composed/PageHeader';
import { RouteError } from '@/components/composed/RouteError';
import { NotFound } from '@/components/composed/NotFound';
import { useDocumentTitle } from '@/lib/hooks/useDocumentTitle';
import { entityId } from '@/lib/api/ids';
import { PortalBankAccountsView } from '@/features/bank-accounts';

/*
 * Portal Bank Accounts — read-only (E02.F08 R107). A Client Billing Contact
 * sees the SAME details Kelly staff see (the account number masked to its last
 * four, the routing number in full — AC-f24d452e) and is offered NO action
 * (AC-fbd7af59). The surface talks only to the BFF, which scopes the read to the
 * client's own organization from the session (R102).
 *
 * The portal is session-scoped (service-context): the BFF resolves "my org"
 * from the session, so the FE reads a self-scoped id rather than carrying the
 * org id in the URL (no org/account id typed at sign-in). The route brands the
 * self placeholder once here (ADR 0007 creation boundary).
 */
const PORTAL_SELF = entityId('org-self');

export const Route = createFileRoute('/_portal/portal/bank-accounts')({
  component: PortalBankAccountsPage,
  errorComponent: RouteError,
  notFoundComponent: NotFound,
});

function PortalBankAccountsPage() {
  useDocumentTitle('Bank Accounts');
  return (
    <Page>
      <PageHeader title="Bank Accounts" />
      <PortalBankAccountsView entityId={PORTAL_SELF} />
    </Page>
  );
}
